import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';
import axios from 'axios';
import { Link } from 'react-router-dom';
import fetchMe from '../../actions/fetchMe';
import { inject, observer } from 'mobx-react'
import UserBox from "./User/UserBox";

class MyAvatar extends Component {
  getAuthUrl() {
    let parsed=qs.parse(this.props.router.location.search,{ ignoreQueryPrefix:true });
    parsed.popup=`/user/auth`;
    const string=qs.stringify(parsed);
    return `${this.props.router.location.pathname}?${string}`;
  }
  getRegistrerUrl() {
    let parsed=qs.parse(this.props.router.location.search,{ ignoreQueryPrefix:true });
    parsed.popup=`/user/register`;
    const string=qs.stringify(parsed);
    return `${this.props.router.location.pathname}?${string}`;

  }
  logOut() {
    this.props.meStore.logOut();
  }
  renderAuthedMenu() {
    return (
      <span>
        <span className="dib pointer clear tdni pc1 logOut" onClick={()=>{ this.logOut() }}>
          {this.props.translateStore.t.menu.logout}
        </span>
        <Link className="dib pointer clear tdni pc1 mleft20" to="/profile/">
          {this.props.translateStore.t.menu.editprofile}
        </Link>
      </span>
    )
  }
  renderGuestMenu(){
    return (
      <div className="ptop20">
        <Link className="dib hpadd20 clear tdni pc1 menuHeight" to={this.getAuthUrl()}>
          {this.props.translateStore.t.user.LOG_IN}
        </Link>
        <Link className="dib hpadd20 clear tdni pc1 menuHeight" to={this.getRegistrerUrl()}>
          {this.props.translateStore.t.menu.register}
        </Link>
      </div>
    )
  }
  render() {
    if(!this.props.meStore.me.data) {
      return (
        <div>
          <div className="font1 fs22 pleft20 ptop20">
            MyAnimeShelf
          </div>
          {this.renderGuestMenu()}
        </div>
      )
    }
    return (
      <div className="padd20 ">
        <div>
          <div className="up12 splice">
            <div className="cell s-shrink s-middle">
              <UserBox size={50} avatar={this.props.meStore.me.data.avatar} nick={this.props.meStore.me.data.nick} />
            </div>
            <div className="cell s-auto s-middle">
              <div className="pleft10">
                <div className="left myNick">
                  @{this.props.meStore.me.data.nick}
                </div>
                <div className="bold myName">{this.props.meStore.me.data.imy} {this.props.meStore.me.data.familiy}</div>
              </div>
            </div>
            <div className="cell s-12 ptop10">
              {this.renderAuthedMenu()}
            </div>
          </div>

        </div>

      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    me:state.me,
    router:state.router,
    t:state.translate,
  }
}

// export default connect(mapStateToProps,{ fetchMe })(MyAvatar);
export default inject("router","translateStore","meStore")(observer(MyAvatar));